import { Header } from "@common/header/headerUnit"
import { joinClassNames } from "@common/lib/util"
import Svg from "@common/svg"
import {
  getCommonCellStyles,
  getIsLastLeftPinnedColumn,
} from "@common/table/column.util"
import { ColumnActionMenu } from "@common/table/menus/columnActionMenu"
import { TableHeadCellProps } from "@common/table/types"
import TooltipInfo from "@common/tooltip/tooltipInfo"
import { Column, flexRender } from "@tanstack/react-table"
import { useTheme } from "next-themes"
import React from "react"

const HeadCell = ({ header, table }: TableHeadCellProps) => {
  const { column } = header
  const {
    options: { themes: tableThemes, showToolbar },
  } = table

  const { theme } = useTheme()
  const computedStyles = getCommonCellStyles({
    column,
    table,
    theme,
    type: "head",
  }) as Record<string, any>

  const columnDef = column.columnDef as any
  const isDisplayColumn = columnDef.type === "display"
  const { info } = columnDef
  const isLastPinnedCol = getIsLastLeftPinnedColumn(table, column)

  return (
    <th
      key={header.id}
      colSpan={header.colSpan}
      onClick={column.getToggleSortingHandler()}
      scope="col"
      style={computedStyles}
      className={joinClassNames(
        tableThemes.tHeadClasses,
        isLastPinnedCol ? "" : "border-r",
        column.getCanSort() ? "cursor-pointer" : "",
        isDisplayColumn ? "" : "px-4 py-3"
      )}
    >
      {header.isPlaceholder ? null : (
        <div className="flex items-center group gap-1">
          <Header.ShortHeader
            color="secondary"
            width={isDisplayColumn ? "full" : "fit"}
          >
            {flexRender(header.column.columnDef.header, header.getContext())}
          </Header.ShortHeader>
          {info && (
            <div>
              <TooltipInfo position={undefined}>
                {info}
              </TooltipInfo>
            </div>
          )}
          {!isDisplayColumn && (
            <div className="flex items-center ml-auto">
              {showToolbar && <ColumnActionMenu table={table} header={header} />}
              <Sort column={header.column} />
            </div>
          )}
        </div>
      )}
    </th>
  )
}

function Sort({ column }: { column: Column<any, any> }) {
  const isSorted = column.getIsSorted() as string

  return (
    <span
      className={joinClassNames(
        "w-3 group-hover:opacity-100 mb-1",
        !isSorted ? "opacity-0" : ""
      )}
    >
      <Svg
        name="arrow-up-short"
        viewBox="0 0 16 16"
        classes={joinClassNames(
          "h-2 w-3",
          isSorted === "asc" ? "opacity-100" : "opacity-50"
        )}
      />
      <Svg
        name="arrow-down-short"
        viewBox="0 0 16 16"
        classes={joinClassNames(
          "h-2 w-3 ",
          isSorted === "desc" ? "opacity-100" : "opacity-50"
        )}
      />
    </span>
  )
}
export default HeadCell
